let encodeTabularDataHashCode = (hashCode) => {
  let h = Number.parseInt(hashCode, 10)
  if (h < 0) {
    let positiveH = h * -1
    return `n${positiveH}`
  }
  return `${h}`
}

export {
  encodeTabularDataHashCode,
}